import { CToast, CToastBody, CToastClose } from '@coreui/react-pro'
import React, { useState } from 'react'
import { ToastPropsType } from '../../types/Components/toastTypes'

const OToast = ({
  toastMessage,
  toastColor,
  isAutoHide = true,
  toastDelay = 2000,
}: ToastPropsType): JSX.Element => {
  const [isHovered, setIsHovered] = useState(false)
  return (
    <CToast
      autohide={isAutoHide && !isHovered}
      visible={true}
      delay={toastDelay}
      className={`text-white align-items-center ${toastColor} ${
        toastMessage ? '' : 'd-none'
      }`}
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
    >
      <div className="d-flex">
        <CToastBody>{toastMessage}</CToastBody>
        <CToastClose className="me-3 m-auto" />
      </div>
    </CToast>
  )
}

export default OToast
